module.exports = __webpack_public_path__ + "static/media/auto-automobile-automotive-2-svgrepo-com.1449b041.svg";